export const API_KEY = 'NI0jEa3nmz0YRjft1G9tnzTobuhlCRKi'
export const API_URL = 'https://api.giphy.com/v1'